import { BaseRequestPolicy, HttpHeaders } from '@azure/ms-rest-js';
import type {
  HttpOperationResponse,
  RequestPolicy,
  RequestPolicyFactory,
  RequestPolicyOptions,
  WebResource,
} from '@azure/ms-rest-js';

import { TokenProvider } from '../helpers/TokenProvider';

class AuthorizationPolicy extends BaseRequestPolicy {
  private readonly headerKey: string = 'Authorization';

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor -- TODO
  constructor(nextPolicy: RequestPolicy, options: RequestPolicyOptions) {
    super(nextPolicy, options);
  }

  async sendRequest(request: WebResource): Promise<HttpOperationResponse> {
    await this.addAuthorizationHeader(request);

    return this._nextPolicy.sendRequest(request);
  }

  private async addAuthorizationHeader(request: WebResource): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/no-unnecessary-condition -- TODO
    if (!request.headers) {
      request.headers = new HttpHeaders();
    }

    const token = await TokenProvider.getToken();
    if (!request.headers.get(this.headerKey)) {
      request.headers.set(this.headerKey, token.toString());
    }
  }
}

export const authorizationPolicy = (): RequestPolicyFactory => ({
  create: (nextPolicy: RequestPolicy, options: RequestPolicyOptions): AuthorizationPolicy =>
    new AuthorizationPolicy(nextPolicy, options),
});
